import React, { useEffect, useState } from "react";
import { ContentInputField } from "../../../components/atoms/formFields/inputField/contentInputField";
import { Col, DatePicker, Row } from "antd";
import moment from "moment/moment";
import media from "../../../media";
import ModalWrapper from "../../../components/atoms/formFields/wrapperModal/modalWrapper";
import { useDispatch } from "react-redux";
import {
  inventoryListThunk,
  updateSaleThunk,
} from "../../../store/thunks/InventoryThunk";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const UpdateSaleModal = ({
  updateSale,
  setUpdateSale,
  setSaleErrors,
  saleErrors,
  storeName,
  setDiscount,
  discount,
  pagination,
  modalIdVariant,
}) => {
  const dispatch = useDispatch();
  const [isEndSaleChange, setIsEndSaleChange] = useState(false);
  const [isStartSaleChange, setIsStartSaleChange] = useState(false);
  return (
    <>
      <ModalWrapper
        name="Update Sale"
        tooltipText={"Update discount, pricing, and sale duration for this product"}
        id={modalIdVariant}
        extraClasses="modal-lg"
      >
        <div className="d-flex justify-content-between pb-4">
          <div className="bg-light-light border border-1 border-light-dark mr-5 p-3 start-sale w-100">
            <div className="align-items-center d-flex flex-wrap">
              <div className="symbol symbol-80 symbol-light-success mr-5">
                <span className="border border-1 border-light-dark symbol-label">
                  <img
                    src={updateSale?.variant?.productImage || media.Default}
                    className="align-self-center h-100 object-fit-cover radius w-100"
                    alt="productImage"
                  />
                </span>
              </div>
              <div className="d-flex flex-column flex-grow-1 my-2 my-lg-0 b text-left">
                <p className="font-size-h6 font-weight-bolder m-0">
                  {updateSale?.variant?.productName?.name?.en}{" "}
                  {updateSale?.variant?.variantName}
                </p>
                <span className="text-muted font-weight-bold font-size-sm">
                  Published on :{" "}
                  {updateSale?.variant?.publishedOn
                    ? moment
                        .utc(updateSale?.variant?.publishedOn)
                        .local()
                        .format("DD/MM/YYYY")
                    : ""}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="sale-table">
          <Row gutter={[12, 12]}>
            <Col xs={24} lg={6}>
              <ContentInputField
                name="Size"
                value={updateSale?.variant?.variantName}
                disabled={true}
              />
            </Col>
            <Col xs={24} lg={6}>
              <ContentInputField
                name="MRP"
                value={updateSale?.variant?.mrp}
                disabled={true}
              />
            </Col>
            <Col xs={24} lg={6}>
              <ContentInputField
                name="Selling Price"
                value={updateSale?.variant?.sellingPrice}
                disabled={true}
              />
            </Col>
            <Col xs={24} lg={6}>
              <ContentInputField
                name="Discount Price"
                placeholder="0"
                value={updateSale?.variant?.saleDiscount}
                disabled={true}
              />
            </Col>

            <Col xs={24} lg={6}>
              <ContentInputField
                name="Sale Discount"
                value={
                  (updateSale?.variant?.saleDiscount /
                    updateSale?.variant?.mrp) *
                  100
                }
                onChange={(e) => {
                  const num = e.target.value;
                  const percent = (num / 100) * updateSale?.variant?.mrp;
                  setDiscount(num);
                  setUpdateSale({
                    ...updateSale,
                    variant: {
                      ...updateSale?.variant,
                      saleDiscount: num < 101 ? percent : "",
                    },
                  });
                }}
              />
              {discount > 100 && (
                <small className="text-danger">
                  Sale Discount Should Be Between 0-100
                </small>
              )}
            </Col>
            <Col xs={24} lg={6}>
              <label className="font-weight-bolder font-size-sm">
                Start Sale <span className="text-danger">*</span>
              </label>
              <DatePicker
                className={saleErrors?.saleStartDate ? "invalid" : ""}
                showTime
                value={
                  updateSale?.variant?.saleStartDate
                    ? isStartSaleChange
                      ? dayjs(updateSale?.variant?.saleStartDate).local()
                      : dayjs(updateSale?.variant?.saleStartDate).local().utc()
                    : null
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(date, dateString) => {
                  setIsStartSaleChange(true)
                  setUpdateSale({
                    ...updateSale,
                    variant: {
                      ...updateSale?.variant,
                      saleStartDate: dateString
                        ? moment(dateString).format("YYYY-MM-DDTHH:mm:ss")
                        : "",
                    },
                  });

                  setSaleErrors({
                    ...saleErrors,
                    saleStartDate: dateString ? "" : "Start Date is required",
                  });
                }}
              />
              {saleErrors?.saleStartDate && (
                <small className="text-danger">
                  {saleErrors?.saleStartDate}
                </small>
              )}
            </Col>
            <Col xs={24} lg={6}>
              <label className="font-weight-bolder font-size-sm">
                End Sale <span className="text-danger">*</span>
              </label>
             
              <DatePicker
                className={saleErrors?.saleEndDate ? "invalid" : ""}
                showTime
                value={
                  updateSale?.variant?.saleEndDate
                    ? isEndSaleChange
                      ? dayjs(updateSale?.variant?.saleEndDate).local()
                      : dayjs(updateSale?.variant?.saleEndDate).local().utc()
                    : null
                }
                getPopupContainer={(trigger) => trigger.parentNode}
                onChange={(date, dateString) => {
                  setIsEndSaleChange(true);
                  setUpdateSale({
                    ...updateSale,
                    variant: {
                      ...updateSale?.variant,
                      saleEndDate: dateString
                        ? moment(dateString).format("YYYY-MM-DDTHH:mm:ss")
                        : "",
                    },
                  });

                  setSaleErrors({
                    ...saleErrors,
                    saleEndDate: dateString ? "" : "End Date is required",
                  });
                }}
              />
              {saleErrors?.saleEndDate && (
                <small className="text-danger">{saleErrors?.saleEndDate}</small>
              )}
            </Col>
          </Row>
          <div className="modal-footer p-3 mt-5">
            <button
              type="button"
              className="btn btn-primary font-weight-bold ml-auto"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary font-weight-bold mr-auto"
              onClick={(e) => {
                e.preventDefault();
                const errors = {
                  saleStartDate: updateSale?.variant?.saleStartDate
                    ? ""
                    : "Start Date is required",
                  saleEndDate: updateSale?.variant?.saleEndDate
                    ? ""
                    : "End Date is required",
                };
                if (errors.saleStartDate || errors.saleEndDate) {
                  setSaleErrors(errors);
                  return;
                }

                if (
                  updateSale?.variant?.saleDiscount <=
                    updateSale?.variant?.mrp &&
                  updateSale?.productId &&
                  updateSale?.variant?.variantId &&
                  storeName
                ) {
                  dispatch(
                    updateSaleThunk({
                      vendorProductVariantSale: {
                        productID: updateSale?.productId,
                        variantId: updateSale?.variant?.variantId,
                        inventoryId: storeName,
                        saleStartDate: updateSale?.variant?.saleStartDate,
                        saleEndDate: updateSale?.variant?.saleEndDate,
                        discountType: "FIXED_DISCOUNT",
                        saleDiscount: updateSale?.variant?.saleDiscount,
                      },
                    })
                  )
                    .unwrap()
                    .then(() => {
                      dispatch(
                        inventoryListThunk({
                          inventoryListingFilters: pagination,
                        })
                      );
                      const modal = window.$(`#${modalIdVariant}`);
                      modal?.modal("hide");
                      setUpdateSale(null);
                      setSaleErrors({});
                    });
                } else {
                  setDiscount();
                }
              }}
            >
              Update
            </button>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default UpdateSaleModal;
